module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/heroFeatured4.jpg";